import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Instagram } from "lucide-react";

export function MagazineFooter() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-border mt-32">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="serif text-3xl md:text-4xl leading-tight">
            {t("footer.issue")}
          </div>
          <p className="mt-4 text-sm text-muted-foreground max-w-md">
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <div className="eyebrow text-muted-foreground mb-4">{t("footer.magazine")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/selected">{t("nav.selected")}</Link></li>
            <li><Link to="/photographers">{t("nav.photographers")}</Link></li>
            <li><Link to="/themes/portraits">{t("nav.themes")}</Link></li>
            <li><Link to="/faq">{t("nav.faq")}</Link></li>
            <li><Link to="/about">{t("nav.about")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow text-muted-foreground mb-4">{t("footer.participate")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/apply">{t("footer.applyPhotographer")}</Link></li>
            <li><Link to="/fuer-fotografen">{t("footer.forPhotographers")}</Link></li>
            <li><Link to="/fuer-visagisten">{t("footer.forVisagists")}</Link></li>
            <li><Link to="/brief">{t("footer.sendBrief")}</Link></li>
            <li>kontakt@omselected.art</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} OM Selected</span>
          <div className="flex flex-wrap gap-x-4 gap-y-1 items-center">
            <Link to="/impressum">{t("footer.imprint")}</Link>
            <Link to="/datenschutz">{t("footer.privacy")}</Link>
            <Link to="/cookies">{t("footer.cookies")}</Link>
            <a
              href="https://instagram.com/om.selected"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1"
            >
              <Instagram className="w-3.5 h-3.5" />
              <span>Instagram</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}